import { useGetAuctionForms } from "apollo/hooks/queries";
import { useEnvContext } from "context/EnvContext";
import { QUERY_PROGRESS_NOT_STARTED } from "core/consts";
import { activateEligibilityFiles } from "core/model/utils/featureFlags";
import { AllPatientForms } from "core/types";

export function useGetFormFiles({
  auctionId,
  consultationId,
  isEligiblePage,
  skip,
}: {
  auctionId: number;
  consultationId: number;
  isEligiblePage?: boolean;
  skip?: boolean;
}) {
  const { isReceiverApp } = useEnvContext();

  const skipQuery =
    !!skip ||
    !activateEligibilityFiles ||
    !!isEligiblePage ||
    isReceiverApp ||
    !auctionId ||
    !!consultationId;

  const [formsProgress, forms] = useGetAuctionForms({
    auctionId,
    skip: skipQuery,
  });

  const allForms: AllPatientForms | undefined =
    skipQuery || forms === undefined ? undefined : { auctionForms: forms };

  return {
    allForms,
    getFormsProgress: skipQuery ? QUERY_PROGRESS_NOT_STARTED : formsProgress,
  };
}
